{
  "navbar": {
    "signedInAs": "Angemeldet als",
    "logout": "Abmelden"
  }
}
